// extracted by css-extract-rspack-plugin
var _1 = "button-element__SAk6a";
var _2 = "current-number__FKOpv";
var _3 = "decrement-button__O0qLq";
var _4 = "increment-button__cMQmt";
var _5 = "widget__aUyJk";
export { _1 as "button-element", _2 as "current-number", _3 as "decrement-button", _4 as "increment-button", _5 as "widget" }
export default { "button-element": _1, "current-number": _2, "decrement-button": _3, "increment-button": _4, "widget": _5 }
